// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"8edc2a7d","249":"c3e3d340","463":"e31e1a9b","494":"bfe0629f","613":"be31419f","787":"501af4a1"}[chunkId] + ".chunk.js";
};